import { render, staticRenderFns } from "./ZXKF.vue?vue&type=template&id=6b498bba&scoped=true"
import script from "./ZXKF.vue?vue&type=script&lang=js"
export * from "./ZXKF.vue?vue&type=script&lang=js"
import style0 from "./ZXKF.vue?vue&type=style&index=0&id=6b498bba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b498bba",
  null
  
)

export default component.exports